import { IconProps } from '../icon-props-interface';
import '../icons.scss';

const IconError = ({ color = 'var(--color-semantic-danger)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="15"
            fill="none"
            viewBox="0 0 15 15"
        >
            <path
                fill={color}
                d="M7.266 0C3.252 0 0 3.281 0 7.266a7.264 7.264 0 0 0 7.266 7.265c3.984 0 7.265-3.252 7.265-7.265C14.531 3.28 11.25 0 7.266 0m0 13.125a5.84 5.84 0 0 1-5.86-5.86 5.86 5.86 0 0 1 5.86-5.859c3.222 0 5.859 2.637 5.859 5.86a5.86 5.86 0 0 1-5.86 5.859m1.23-3.047c0-.674-.557-1.23-1.23-1.23a1.22 1.22 0 0 0-1.23 1.23c0 .703.527 1.23 1.23 1.23a1.22 1.22 0 0 0 1.23-1.23M6.094 3.896l.205 3.985c0 .176.176.322.351.322h1.202c.175 0 .351-.146.351-.322l.205-3.985c0-.205-.146-.38-.351-.38H6.445c-.205 0-.351.175-.351.38"
            ></path>
        </svg>
    </div>
);

export default IconError;
